import './index.scss';

export default function InputNumber(props) {
  const { value, onChange } = props;

  // Ensure value is never undefined or null
  const safeValue = value ?? '';

  return (
    <div className="input-number">
      <i
        className="icon-minus"
        onClick={() => {
          const current = Number(value) || 0;
          if(current === 0) return;
          onChange(current - 1);
        }}
      />
      <input
        type="number"
        value={safeValue}
        onChange={(e) => {
          const newValue = e.target.value > 0 ? e.target.value : 0;
          onChange(newValue === '' ? '' : Number(newValue));
        }}
      />
      <i
        className="icon-plus"
        onClick={() => {
          const current = Number(value) || 0;
          onChange(current + 1);
        }}
      />
    </div>
  );
}